var exports = {
  "y_": "x43aef4ae--458b13--pin",
  "C0": "x43aef4ae--458b13--pin-default",
  "VL": "x43aef4ae--458b13--pin-plus",
};

module.exports = exports;
